import { AppLayout } from 'layouts';
import { Help } from 'features/account';

const PageHelp = () => (
  <AppLayout>
    <Help />
  </AppLayout>
);

export default PageHelp;
